import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {Button, Screen} from '../components';
import {
    fetchAiAddons,
    cleanAiAddons,
    setUser,
    changeUserSetting,
} from '../actions';
import {__, formatAmount, getCurrency, toNumber} from '../functions';
import '../assets/styles/ai-addons.css';
import {IMAGES,AI_ADDON_NAMES} from "../config";
import {Chip} from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AddIcon from "@mui/icons-material/AddCircle";

class AiAddonsScreen extends Screen {
    title = __('AI doplnky');

    state = {};

    async componentDidMount() {
        if (super.componentDidMount()) {
            if (!this.hasPermission('aiaddons')) {
                window.location = '/';
                return false;
            }

            const { fetchAiAddons } = this.props;

            await fetchAiAddons(this);
        }

        return true;
    }

    componentWillUnmount() {
        const { cleanAiAddons } = this.props;

        cleanAiAddons();
    }

    render() {
        const { items, user } = this.props;

        if (_.isEmpty(items)) {
            // Data nie su nacitane
            return this.renderLoading();
        }

        if (!this.hasPermission('aiaddons')) {
            return null;
        }

        const activeSlugs = _.reduce(items.addons, (result, item) => {
            return [ ...result, item.slug ];
        }, []);

        const user_eshop_id = toNumber(user.user_eshop_id);

        return (
            <div className="ai-addons">
                <div className="ai-addons__header">
                    <div className="ai-addons__header__left">
                        <div className="ai-addons__header__left__title">{__('AI doplnky')}</div>
                        <div className="ai-addons__header__left__tags">
                            <Chip
                                onClick={() => this.redirect('/ai-transactions')}
                                color="secondary"
                                label={`${__('Aktuálny kredit')}: ${formatAmount(items.credit, 'EUR', 4)}`}
                                icon={<MonetizationOnIcon />}
                            />
                            <Chip
                                onClick={() => this.redirect('/ai-transactions')}
                                color="secondary"
                                label={__('Dobiť kredit')}
                                icon={<AddIcon />}
                                className="ai-credit-tag"
                            />
                        </div>
                    </div>
                </div>
                <div className="ai-addons__content">
                    <div className="ai-addons__content__item">
                        <div className="ai-addons__content__item__header">
                            <div className="ai-addons__content__item__header__title">{AI_ADDON_NAMES.related_products}</div>
                            <div className="ai-addons__content__item__header__right">
                                {_.includes(activeSlugs, 'related_products') ? <div className="ai-addons__content__item__header__right__active">{__('Aktivované')}</div> : null}
                            </div>
                        </div>
                        <div className="ai-addons__content__item__photo">
                            <img src={IMAGES['ai-addon-related-products.jpg']} />
                        </div>
                        <div className="ai-addons__content__item__text">
                            <p><strong>{__('Chytré odporúčanie produktov – Zvyšujte predaje pomocou dát')}</strong></p>
                            <p>{__('Inteligentný modul ktorý zobrazuje zákazníkom tie produkty, ktoré si najčastejšie kupujú spolu – na základe reálnych objednávok, nie náhodných algoritmov.')}</p>
                            <p>{__('Náš AI systém analyzuje vaše objednávky za posledného pol roka a zistí ktoré produkty sa kupujú spolu, ako často sa vyskytujú v jednej objednávke, či majú spoločné kategórie alebo podkategórie. Na základe toho každý produkt automaticky aktualizujeme v eshope a nastavujeme tie najpravdepodobnejšie "podobné produkty", ktoré zákazníci s najväčšou pravdepodobnosťou dokúpia.')}</p>
                        </div>
                        <Button
                            onClick={() => this.redirect('/ai-addons/view/related_products')}
                            disabled={user_eshop_id === 0}
                        >{__('Nastavenie')}</Button>
                    </div>
                    <div className="ai-addons__content__item">
                        <div className="ai-addons__content__item__header">
                            <div className="ai-addons__content__item__header__title">{AI_ADDON_NAMES.search}</div>
                            <div className="ai-addons__content__item__header__right">
                                {_.includes(activeSlugs, 'search') ? <div className="ai-addons__content__item__header__right__active">{__('Aktivované')}</div> : null}
                            </div>
                        </div>
                        <div className="ai-addons__content__item__photo">
                            <img src={IMAGES['ai-addon-search.jpg']} />
                        </div>
                        <div className="ai-addons__content__item__text">
                            <p><strong>{__('AI vyhľadávanie pre eshopy – nájde presne to, čo zákazník hľadá')}</strong></p>
                            <p>{__('Zabudnite na zastarané fulltextové vyhľadávanie. S naším novým AI Search modulom nájde váš zákazník presne tie produkty, ktoré hľadá – aj keď ich nenazve úplne presne.')}</p>
                            <p>{__('Náš systém využíva umelú inteligenciu, ktorá rozumie významu slov, kontextu a správania zákazníkov. Výsledkom je, že zákazník nájde správny produkt aj pri preklepe alebo inom názve. Zohľadňujeme synonymá a bežné formulácie (napr. "mixér" = "šľahač"). Uprednostňujeme najpredávanejšie a najobľúbenejšie produkty.')}</p>
                        </div>
                        <Button
                            onClick={() => this.redirect('/ai-addons/view/search')}
                            disabled={user_eshop_id === 0}
                        >{__('Nastavenie')}</Button>
                    </div>
                    <div className="ai-addons__content__item">
                        <div className="ai-addons__content__item__header">
                            <div className="ai-addons__content__item__header__title">{AI_ADDON_NAMES.chat}</div>
                            <div className="ai-addons__content__item__header__right">
                                {_.includes(activeSlugs, 'chat') ? <div className="ai-addons__content__item__header__right__active">{__('Aktivované')}</div> : null}
                            </div>
                        </div>
                        <div className="ai-addons__content__item__photo">
                            <img src={IMAGES['ai-addon-chatbot.jpg']} />
                        </div>
                        <div className="ai-addons__content__item__text">
                            <p><strong>{__('AI Chatbot pre eshop – odpovedá, pomáha a predáva za vás')}</strong></p>
                            <p>{__('Predstavujeme inteligentného AI chatbota, ktorý zvládne komunikáciu so zákazníkmi 24/7, odpovie na najčastejšie otázky, poskytne stav objednávky, odporučí vhodné produkty a pomôže urýchliť nákupný proces – bez potreby operátora.')}</p>
                            <p>{__('Náš chatbot využíva umelú inteligenciu, ktorá rozumie prirodzenému jazyku a vie reagovať presne podľa vašich podkladov. Stačí, ak mu nahráte inštrukcie, ako má odpovedať (napr. tón komunikácie, odporúčané riešenia), podklady vo forme príloh alebo často kladené otázky (FAQ).')}</p>
                        </div>
                        <Button
                            onClick={() => this.redirect('/ai-addons/view/chat')}
                            disabled={user_eshop_id === 0}
                        >{__('Nastavenie')}</Button>
                    </div>
                </div>
            </div>
        );
    }
}

const stateToProps = ({ ai_addons, user }) => ({ items: ai_addons, user });

export default withCookies(connect(stateToProps, {
    fetchAiAddons,
    cleanAiAddons,
    setUser,
    changeUserSetting,
})(AiAddonsScreen));
